/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6886577e"]'><div :class='["radio-modal-default-demo"]'><cube-radio-modal ref="__mpx_ref_radioModal__" title="请选择支付方式" subtitle="将按已选择的支付方式优先支付，若不支持该支付方式的⻋型则默认为上次所选支付方式" :show-close-icon="(true)" :options="(options)" :value="(checkedValue)" @close='(e)=>__invoke(e, [["onClose"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])'/><cube-button @_click="onTap">radio-modal-option-conf</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_6886577e"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6886577e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6886577e"}
  /** script content **/
  require("./radio-modal-option-conf.mpx.js?isComponent&outputPath=components%2Fradio-modal-option-conf6886577e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./radio-modal-option-conf.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fradio-modal-option-conf6886577e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6886577e"],
    ctorType: "component",
    outputPath: "components/radio-modal-option-conf6886577e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-radio-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-modal/index.mpx?isComponent&outputPath=components%2Findex253dfa48%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>